<form [formGroup]="resetPasswordForm" class="form">

<!-- reset password heading -->
<div class="form__heading-container">
    <ion-text class="form__heading">
        {{ 'label.reset_password' | translate }}
    </ion-text>
</div>

<!-- new password field -->
<div class="w-full w-100 form__form-field mb-3">
    <mat-label class="form__input-label"
        >{{ 'label.new_password' | translate }} </mat-label
    >
    <mat-form-field>
        <input
            matInput
            [type]="hide ? 'password' : 'text'" 
            required
            appNoLeadingTrailingSpaces
            data-cy="app-reset-password-form-new-field"
            [(ngModel)]="resetPasswordData['password']"
            (ionFocus)="onTouch()"
            (input)="checkPasswordValidation($event.target)"
            (keyup.enter)="submitResetPasswordForm()"
            formControlName="password"/>
            <ion-icon matSuffix (click)="hide = !hide" name="{{ hide ? 'eye-off' : 'eye' }}"></ion-icon>
        <mat-error appFieldErrors></mat-error>
    </mat-form-field>

    <div *ngIf="showValidationMessages" class="validation-list">
        <div
            [ngClass]="{
                valid: global.isPasswordValid.minLength,
                invalid: !global.isPasswordValid.minLength
            }">
            <span>{{ global.isPasswordValid.minLength ? '✔️' : '❌' }}</span> At least 8 characters long
        </div>
        <div
            [ngClass]="{
                valid: global.isPasswordValid.lowerCase,
                invalid: !global.isPasswordValid.lowerCase
            }">
            <span>{{ global.isPasswordValid.lowerCase ? '✔️' : '❌' }}</span> At least one lowercase letter
        </div>
        <div
            [ngClass]="{
                valid: global.isPasswordValid.upperCase,
                invalid: !global.isPasswordValid.upperCase
            }">
            <span>{{ global.isPasswordValid.upperCase ? '✔️' : '❌' }}</span> At least one uppercase letter
        </div>
        <div [ngClass]="{valid: global.isPasswordValid.number, invalid: !global.isPasswordValid.number}">
            <span>{{ global.isPasswordValid.number ? '✔️' : '❌' }}</span> Contains at least one number
        </div>
        <div [ngClass]="{valid: global.isPasswordValid.symbol, invalid: !global.isPasswordValid.symbol}">
            <span>{{ global.isPasswordValid.symbol ? '✔️' : '❌' }}</span> Contains at least one symbol
            (!@#$%^&*)
        </div>
    </div>
</div>

<!-- confirm password field -->
<div class="w-full w-100 form__form-field">
    <mat-label class="form__input-label">{{ 'label.confirm_password' | translate }} </mat-label>
    <mat-form-field>
        <input 
        matInput 
        [type]="hideConfirmPassword ? 'password' : 'text'" 
        required
        [(ngModel)]="resetPasswordData['password2']"
        (ionFocus)="onTouch()"
        (keyup.enter)="submitResetPasswordForm()"
        formControlName="password2"/>
        <ion-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" name="{{ hideConfirmPassword ? 'eye-off' : 'eye' }}"></ion-icon>
        <mat-error appFieldErrors></mat-error>
    </mat-form-field>
</div>

<!-- reset button -->
<ion-button
type="submit"
class="w-full btn__primary form__btn w-100"
tappable
expand="block"
[disabled]="!resetPasswordForm.valid || resetPasswordData['password'] !== resetPasswordData['password2'] || !resetPasswordData['password'] "
id="resetPasswordBtn"
(click)="submitResetPasswordForm()"
>
{{ 'label.update_password' | translate }}</ion-button>
</form>
